import { EventBus } from '@/utils/event-bus'

class VideoPlaybackService {
  showVideo(src) {
    EventBus.$emit('video-playback:show', src)
  }
}

export default VideoPlaybackService
